import { render, staticRenderFns } from "./IntegrationSettingPage.vue?vue&type=template&id=48473b36&scoped=true&"
import script from "./IntegrationSettingPage.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettingPage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSettingPage.vue?vue&type=style&index=0&id=48473b36&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48473b36",
  null
  
)

export default component.exports